import { useAppSelector } from '@/redux/hooks';
import { getFeaturedAuctioneers } from '@/redux/modules/home/home.selectors';

import { FeaturedAuctioneersCarousel } from './FeaturedAuctioneersCarousel';
import { FeaturedAuctioneersGrid } from './FeaturedAuctioneersGrid';

type Props = {
    shouldUseHomePageRedesign?: boolean;
};

export const FeaturedAuctioneers = ({ shouldUseHomePageRedesign = false }: Props) => {
    const featuredAuctioneers = useAppSelector(getFeaturedAuctioneers) ?? [];

    if (shouldUseHomePageRedesign) {
        return <FeaturedAuctioneersGrid featuredAuctioneers={featuredAuctioneers} />;
    }

    return <FeaturedAuctioneersCarousel featuredAuctioneers={featuredAuctioneers} />;
};
